import React from 'react';

import type { TooltipProps } from '../../types/componentType';


const renderWrapper = ({
  Component,
  label,
  className,
  children,
}: {
  Component: React.ElementType;
  label: string;
  className?: string;
  children: React.ReactNode;
}) =>
  React.createElement(
    Component,
    {
      title: label,
      'aria-label': label,
      className,
    },
    children,
  );

const Tooltip: React.FC<TooltipProps> = ({ label, children, asWrapper = 'span', className }) => {
  if (!React.isValidElement(children)) {
    return renderWrapper({ Component: asWrapper, label, className, children });
  }

  const isDomElement = typeof children.type === 'string';
  if (isDomElement) {
    const element = children as React.ReactElement<Record<string, unknown>>;
    const childProps = element.props as Record<string, unknown> & {
      className?: string;
      title?: string;
      'aria-label'?: string;
    };
    const existingAriaLabel = childProps['aria-label'];
    const mergedClassName = className
      ? [childProps.className, className].filter(Boolean).join(' ')
      : childProps.className;

    return React.cloneElement(element, {
      title: label,
      'aria-label': existingAriaLabel || label,
      className: mergedClassName,
    });
  }

  return renderWrapper({ Component: asWrapper, label, className, children });
};

export default Tooltip;


